import { render, staticRenderFns } from "./DebrisFieldEditor.vue?vue&type=template&id=77dd048f&scoped=true&"
import script from "./DebrisFieldEditor.vue?vue&type=script&lang=js&"
export * from "./DebrisFieldEditor.vue?vue&type=script&lang=js&"
import style0 from "./DebrisFieldEditor.vue?vue&type=style&index=0&id=77dd048f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77dd048f",
  null
  
)

export default component.exports